import { ReactNode } from 'react';

interface PageHeaderProps {
  breadcrumb?: ReactNode;
  title: string;
  subtitle?: ReactNode;
  extra?: ReactNode;
}

export function PageHeader({ breadcrumb, title, subtitle, extra }: PageHeaderProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        marginBottom: 20,
        gap: 12,
        flexWrap: 'wrap',
      }}
    >
      <div style={{ minWidth: 0, flex: '1 1 auto' }}>
        {breadcrumb && (
          <div
            className="mono"
            style={{ fontSize: 11, color: '#7d8a98', marginBottom: 4, letterSpacing: 0.3 }}
          >
            {breadcrumb}
          </div>
        )}
        <h1 style={{ fontSize: 22, fontWeight: 600, color: '#1a1e23', margin: 0, lineHeight: 1.3 }}>
          {title}
        </h1>
        {subtitle && (
          <div style={{ fontSize: 13, color: '#5b6875', marginTop: 4 }}>{subtitle}</div>
        )}
      </div>
      {extra && <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>{extra}</div>}
    </div>
  );
}

export function Card({
  children,
  title,
  extra,
  padding = 20,
}: {
  children: ReactNode;
  title?: ReactNode;
  extra?: ReactNode;
  padding?: number;
}) {
  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid #d4d9df',
        borderRadius: 8,
        overflow: 'hidden',
      }}
    >
      {title && (
        <div
          style={{
            padding: '12px 16px',
            borderBottom: '1px solid #eceef1',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: 14,
            fontWeight: 600,
            color: '#1a1e23',
          }}
        >
          <span>{title}</span>
          {extra}
        </div>
      )}
      <div style={{ padding }}>{children}</div>
    </div>
  );
}
